import { useMutation } from "react-query";
import { useStoreCRMSearch } from "../stores/useStoreCRMSearch";
import { searchCRMRecords } from "../apis/crm";

export const useCRMSearchRecords = ({ onSuccess, onError, onStream } = {}) => {
  const { addChunkInCRMBulkSearchData } = useStoreCRMSearch();

  return useMutation(
    ({ data, configId, options }) =>
      searchCRMRecords({
        data,
        configId,
        options,
        onStream: (chunk) => {
          // Internal store update
          addChunkInCRMBulkSearchData(chunk);
          // Custom consumer stream handler
          onStream?.(chunk);
        },
      }),
    {
      onSuccess: (data, variables, context) => {
        console.log("on success bulk search", data);
        // Internal post-success logic (if needed here)
        // Then user-provided callback
        onSuccess?.(data, variables, context);
      },
      onError: (error, variables, context) => {
        console.error("❌ Bulk search stream error:", error);
        onError?.(error, variables, context);
      },
    }
  );
};
